export default "__VITE_ASSET__CLsM9ROt__"